import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  quote: string;
  role?: string;
}
export function TestimonialCard({
  name,
  location,
  quote,
  role = 'Docente de Historia'
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-amber-100 relative" data-id="element-26">
      <Quote className="absolute top-4 right-4 w-8 h-8 text-amber-200 opacity-50" data-id="element-27" />
      <div className="flex flex-col h-full" data-id="element-28">
        <p className="text-gray-700 italic mb-6 text-lg leading-relaxed" data-id="element-29">
          "{quote}"
        </p>
        <div className="mt-auto flex items-center gap-3 border-t border-gray-100 pt-4" data-id="element-30">
          <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 font-bold text-lg" data-id="element-31">
            {name.charAt(0)}
          </div>
          <div data-id="element-32">
            <p className="font-bold text-gray-900" data-id="element-33">{name}</p>
            <p className="text-sm text-gray-500" data-id="element-34">{location}</p>
          </div>
        </div>
      </div>
    </div>;
}